import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store } from "./app/store";
import SideBarProvider from "./context/sideBar";
import ImageResizerProvider from "./context/imageResizer";

const domNode = document.getElementById("root");
const root = createRoot(domNode);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <SideBarProvider>
        <ImageResizerProvider>
          <App />
        </ImageResizerProvider>
      </SideBarProvider>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
